import { ApiCaller } from '../../utils/api'
import { URLS } from '../../utils/url'
const state = {
  subscriptionPackages: [],
  modalSubscriptionPackages: [],
}

const mutations = {
  SET_SUBSCRIPTION_PACKAGES(state, payload) {
    state.subscriptionPackages = [].concat(payload)
  },
  SET_MODAL_SUBSCRIPTION_PACKAGES(state, payload) {
    state.modalSubscriptionPackages = [].concat(payload)
  },
}

const actions = {
  async fetchSubscriptionPackages({ state, commit }, params) {
    const response = await ApiCaller().get(URLS.SUBSCRIPTION_PACKAGES(), { params: params })
    if (response) {
      commit('SET_SUBSCRIPTION_PACKAGES', response.data.data)
    }
  },
  async fetchModalSubscriptionPackages({ state, commit }, params) {
    if (params != null && params.type == "reset") {
      commit('SET_MODAL_SUBSCRIPTION_PACKAGES', [])
    } else {
      const response = await ApiCaller().get(URLS.SUBSCRIPTION_PACKAGES(), { params: params })
      if (response) {
        commit('SET_MODAL_SUBSCRIPTION_PACKAGES', response.data.data)
      }
    }
  },
}

export default {
  namespaced: true,
  state, mutations, actions
}
